import React from 'react';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { FDLabelText } from '@facet-wealth/design';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { Layout } from './Layout';
import { metaOverrideSet } from '../metaOverrideSet';

const localMetaOverrideSet = metaOverrideSet.nameOverride(['assetsHelperText'], {
  _component: () => FDLabelText,
  _customProps: { color: 'textDisabled' },
}, overrideReadOnly);

export const Template = () => {
  const { pageContentResource } = usePageContentContext();

  return (
    <MetaResourceRenderer
      resource={pageContentResource}
      layout={Layout}
      metaOverrideSet={localMetaOverrideSet}
    />
  );
};
